import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

//- material-ui
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import StationContainer from '../../containers/Station';
import GasBuddyPricesForStationContainer from '../../containers/reports/GasBuddyPricesForStation';
import EnhancedTableHead from '../../components/EnhancedTableHead';
import { sortStationTable } from '../../libs/utility';

import {
	LineChart,
	Line,
	Legend,
	ResponsiveContainer,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
} from 'recharts';
import FMPHeadline from '../../components/ui/FMPHeadline';
import AddRetailPrice from '../../components/AddRetailPrice';
import SendSmsPricingRequest from '../../components/SendSmsPricingRequest';

const styles = () => ({
	paper: {
		width: '100%',
		overflowX: 'auto',
		marginBottom: 30,
	},
	row: {
		cursor: 'pointer',
	},
	button: {
		verticalAlign: 'middle',
		padding: '8px 10px',
	},
	formControl: {
		fontSize: 14,
		marginLeft: 20,
		flex: 1,
	},
});

const gasBuddyColumns = [
	{ id: 'reportedDateTime', numeric: false, label: 'Reported Date' },
	{ id: 'lockedUntilDateTime', numeric: false, label: 'Locked Until' },
	{ id: 'sourceDisplay', numeric: true, label: 'Source' },
	{ id: 'gasBuddyPrice', numeric: true, label: 'Retail Price' },
	//{ id: 'quotedPrice', numeric: true, label: 'Quoted Price' },
	//{ id: 'totalCost', numeric: true, label: 'Cost' },
	{ id: 'totalCost', numeric: true, label: 'Invoiced Cost' },
	{ id: 'estimatedMargin', numeric: true, label: 'Estimated Margin' },
	{ id: 'stationInvoiceDisplay', numeric: true, label: 'Invoice #' },
];

// Where I left off TODO:
// Right now the bottom table just works off the collection I need to move that over to
// the new gasBuddyPriceWithMargin and list that data in the table
// Then I need to do the same for the graph up above and not show the quoted price
// but instead show the invoiced price

class Label extends Component {
	render() {
		const { x, y, stroke, value } = this.props;
		return (
			<text x={x} y={y} dy={-4} fill={stroke} fontSize={10} textAnchor="middle">
				{value}
			</text>
		);
	}
}
Label.propTypes = {
	x: PropTypes.number,
	y: PropTypes.number,
	stroke: PropTypes.number,
	value: PropTypes.number,
};

class GasBuddyPricesForStation extends Component {
	constructor(props) {
		super(props);

		const stationId = parseInt(_.get(this.props, ['match', 'params', 'stationId']), 10);
		this.state = {
			stationId,
			order: 'desc',
			orderBy: 'reportedDateTime',
		};

		this.handleRequestSort = this.handleRequestSort.bind(this);
	}

	componentDidMount() {
		const { stationId } = this.state;
		if (!this.props.historicalGasBuddyPrices) {
			this.props.getHistoricalGasBuddyPrices({ stationId });
		}

		if (!this.props.station) {
			this.props.getStation({
				params: { stationIds: [stationId] },
			});
		}
	}

	handleRequestSort(property) {
		const orderBy = property;
		let order = 'desc';

		// noinspection JSValidateTypes
		if (this.state.orderBy === property && this.state.order === 'desc') {
			order = 'asc';
		}
		this.setState({ order, orderBy });
	}

	render() {
		const {
			historicalGasBuddyPrices,
			station,
			classes,
			authUser,
			userMap,
			gasBuddyPriceMap,
		} = this.props;

		if (!historicalGasBuddyPrices || !station || !authUser) {
			return <div>Fetching records...</div>;
		}

		const { order, orderBy, stationId } = this.state;
		console.log('gasBuddyPricesWithMargin');

		let chartRows = [];
		let rows = historicalGasBuddyPrices.map((gasBuddyPricesWithMargin) => {
			const {
				//reportedDateTime, lockedUntilDateTime
				gasBuddyPriceId,
				costBasedOnStationInvoiceId,
				//costFromDeliveryDate,
				costPerGallon,
				estimatedMargin,
			} = gasBuddyPricesWithMargin;

			const gasBuddyPriceRow = gasBuddyPriceMap[gasBuddyPriceId];
			if (!gasBuddyPriceRow) {
				return {
					reportedDateTimeDisplay: 'Missing price?',
				};
			}

			const { reportedDateTime, lockedUntilDateTime, gasBuddyPrice } = gasBuddyPriceRow;

			const reportedDateTimeDisplay = moment(reportedDateTime).format('M/D/YY h:mm a');

			chartRows.push({
				name: reportedDateTimeDisplay,
				gasBuddyPrice,
				totalCost: costPerGallon,
			});

			let sourceDisplay = _.toUpper(gasBuddyPriceRow.source);
			if (gasBuddyPriceRow.createdByUserId) {
				const user = userMap[gasBuddyPriceRow.createdByUserId] || {
					firstName: 'Missing',
					lastName: '',
				};
				sourceDisplay = `${user.firstName} ${user.lastName}`;
			}

			let lockedUntilDateTimeDisplay = '-';
			if (lockedUntilDateTime) {
				lockedUntilDateTimeDisplay = moment(lockedUntilDateTime).format('M/D/YY h:mm a');
			}

			return {
				reportedDateTime,
				lockedUntilDateTimeDisplay,
				lockedUntilDateTime,
				reportedDateTimeDisplay,
				sourceDisplay,
				gasBuddyPrice,
				//quotedPrice: row.quotedPrice,
				costPerGallon,
				estimatedMargin,
				costBasedOnStationInvoiceId,
				stationInvoiceDisplay: costBasedOnStationInvoiceId,
			};
		});

		chartRows = _.sortBy(chartRows, 'reportedDateTIme');
		rows = sortStationTable({ rows, orderBy, order });

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<div>
						<Grid container spacing={3}>
							<Grid item xs={8}>
								<Typography variant="h5" align="left" gutterBottom className={classes.title}>
									<span>
										Retail Prices for {station.number} - {station.name}{' '}
									</span>
								</Typography>
							</Grid>
						</Grid>

						<Paper className={classes.paper}>
							<div style={{ padding: 20 }}>
								Average per day of the week
								<ResponsiveContainer width="100%" height={300}>
									<LineChart data={chartRows} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
										<XAxis
											dataKey="name"
											tickFormatter={(date) => {
												return moment(date).format('M/D/YY h:mm a');
											}}
										/>
										<YAxis
											tickFormatter={(v) => {
												return v.toFixed(2);
											}}
										/>
										<CartesianGrid strokeDasharray="3 3" />
										<Tooltip />
										<Legend verticalAlign="top" height={36} />
										<Line
											type="monotone"
											name="Retail Price"
											dataKey="gasBuddyPrice"
											stroke="#8884d8"
											strokeWidth={3}
											label={<Label />}
										/>
										<Line
											type="monotone"
											name="Total Cost"
											dataKey="totalCost"
											stroke="#82ca9d"
											strokeWidth={3}
											label={<Label />}
										/>
									</LineChart>
								</ResponsiveContainer>
							</div>
						</Paper>

						<Grid container spacing={3}>
							<Grid item xs={8}>
								<FMPHeadline label={`Send SMS Price Request`} />
							</Grid>
						</Grid>

						<Paper className={classes.paper}>
							<div style={{ padding: `30px 20px` }}>
								<SendSmsPricingRequest station={station} />
							</div>
						</Paper>

						<Grid container spacing={3}>
							<Grid item xs={8}>
								<FMPHeadline label={`Add Retail Price`} />
							</Grid>
						</Grid>

						<Paper className={classes.paper}>
							<div style={{ padding: `30px 20px` }}>
								<AddRetailPrice
									stationId={stationId}
									afterSave={() => {
										this.props.getHistoricalGasBuddyPrices({ stationId });
									}}
								/>
							</div>
						</Paper>

						<Paper className={classes.paper}>
							<div style={{ padding: 20 }}>
								<Table>
									<EnhancedTableHead
										columnData={gasBuddyColumns}
										order={order}
										orderBy={orderBy}
										onRequestSort={this.handleRequestSort}
									/>
									<TableBody>
										{rows.map((n, i) => {
											return (
												<TableRow hover key={i}>
													<TableCell>{n.reportedDateTimeDisplay}</TableCell>
													<TableCell>{n.lockedUntilDateTimeDisplay}</TableCell>
													<TableCell align="right">{n.sourceDisplay}</TableCell>
													<TableCell align="right">{n.gasBuddyPrice}</TableCell>
													<TableCell align="right">{n.costPerGallon}</TableCell>
													<TableCell align="right">{n.estimatedMargin}</TableCell>
													<TableCell align="right">
														<a
															href={`/accounting/stationInvoice/update/${n.costBasedOnStationInvoiceId}`}
															target="_blank"
															rel="noreferrer noopener"
														>
															#{n.costBasedOnStationInvoiceId}
														</a>
													</TableCell>
												</TableRow>
											);
										})}
									</TableBody>
								</Table>
							</div>
						</Paper>
					</div>
				</Grid>
			</Grid>
		);
	}
}

GasBuddyPricesForStation.propTypes = {
	classes: PropTypes.object.isRequired,
	getHistoricalGasBuddyPrices: PropTypes.func.isRequired,
	historicalGasBuddyPrices: PropTypes.array,

	getStation: PropTypes.func.isRequired,
	station: PropTypes.object,
	userMap: PropTypes.object,
	gasBuddyPriceMap: PropTypes.object,

	order: PropTypes.string,
	orderBy: PropTypes.string,
	history: PropTypes.object,
	authUser: PropTypes.object,
};

export default _.flow([withStyles(styles), StationContainer, GasBuddyPricesForStationContainer])(
	GasBuddyPricesForStation
);
